import { useEffect } from "react";
import './App.css';
import Navbar from './globalComponents/Components/Navbar';
import Microsoft365 from './m365/Components/index';
import FooterSection from './globalComponents/Components/FooterSection';
import { BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import VdiSolutionsIndex from './pages/services/vdi/components/index';
// import ProtectCloud from './endpointmanagement/Componentsp/ProtectCloud';
// import CopilotIndex from "./pages/modernworkspace/copilotintegration/components/index"
// import ProtectCloudFeatures from './endpointmanagement/Componentsp/ProtectCloudFeatures';
// import CyberProtectPackages from './endpointmanagement/Componentsp/CyberProtectPackages';
import CopilotIndex from "./pages/modernworkspace/CopilotIntegration2/components/index"
import Index from "./pages/solutions/cloudadoptionandmigration/components/index"
import CareerIndex from './pages/company/career/components/index'
import ContactUSIndex from './pages/company/contactus/components/index'
import DisasterRecovery from "./pages/services/disaster/components/index1";
import Business from "./pages/services/backup-as-a-service/component/index1";
import Infrastructure from "./pages/services/hosted-infrastructure/components/index";
import AboutUs from './pages/company/aboutus/components';
import Edcatoindex from './pages/solutions/Edcato/components/index';
import Applicationindex from './pages/solutions/application-development/components';
import ScrollToTop from './globalComponents/Components/ScrollToTop';
import Home from "./pages/home/componentsh/index";
import PrivacyPolicy from './pages/privacy/PrivacyPolicy';
import EndPointManagement from "./endpointmanagement/Componentsp/index";



function App() {
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      const prev = window.history.scrollRestoration;
      window.history.scrollRestoration = "manual";
      return () => {
        window.history.scrollRestoration = prev;
      };
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          {/* Root path - redirect to home */}
          {/* <Route path="/" element={<Navigate to="/home" replace />} />

          <Route path="/home" element={<Home />} /> */}
          <Route path="/" element={<Home />} />

          {/* <Route path="/services/endpoint" element={
            <>
              <ProtectCloud />
              <ProtectCloudFeatures />
              <CyberProtectPackages />
            </>
          } /> */}

          <Route path="/services/endpoint" element={<EndPointManagement/> } />

          <Route path="/services/disaster" element={<DisasterRecovery />} />

          <Route path="/services/backup" element={<Business />} />

          <Route path="/workplace/copilot" element={<CopilotIndex />} />

          <Route path="/solutions/cloud-adoption" element={<Index />} />

          <Route path="/solutions/edcato" element={<Edcatoindex />} />

          <Route path="/services/infrastructure" element={<Infrastructure />} />

          <Route path="/workplace/microsoft-365" element={<Microsoft365 />} />

          <Route path="/company/careers" element={<CareerIndex />} />

          <Route path="/company/about" element={<AboutUs />} />

          <Route path="/company/contact" element={<ContactUSIndex />} />

          <Route path="/services/daas" element={<VdiSolutionsIndex />} />

          <Route path="/solutions/application-development" element={<Applicationindex />} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />


          {/* Catch-all route for 404 - redirect to home */}
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
        <FooterSection />
      </div>
    </Router>
  );
}

export default App;